import SuperAdminDashboardUsersComponent from "./SuperAdminDashboardUsers.container";

export default SuperAdminDashboardUsersComponent;
